const AboutPage = () => {
  return (
    // About page describing a brief summary of myself
    <div id="about" className="bg-primary flex flex-col items-center pt-[120px] pb-40">
      <h1 className="text-5xl font-bold text-center pb-20">About</h1>
      <p className="text-2xl text-start w-3/4">
        Hello, my name is Amer. I am a software engineer with a background in business and technology. I am passionate about coding, along with my freelance work, I love creating personal projects to help me grow as a developer. Over the years, I have learned a great deal and can write effiecent code with seamless UI. My experience as a freelance software engineer has taught me a lot, which has been immensely helpful in this profession. I volunteer for non-profits and help them with their website
        development!
      </p>
    </div>
  );
};

export default AboutPage;
